const translate: { [key: string]: string } = {
  'Email or Password are invalid': 'Email ou senha inválidos',
  'This product already have active promotion':
    'Este produto já possui uma promoção ativa',
};

export const getErrorMessage = (error: string) => {
  return translate[error] || error;
};
